module.exports = __webpack_public_path__ + "media/fonts/materialdesignicons-webfont-53f53f50a1b2033979f58d724a02a7e5.eot";